import { Box, Container, Typography } from "@mui/material";

const Loading = () => (
  <Container>
    <Box sx={{ marginTop: "3.75rem" }} />
    <Typography variant="h4" sx={{ fontWeight: 600 }}>
      ...Loading
    </Typography>
  </Container>
);

export default Loading;
